<ng-container *ngIf="(graph | async) as graph; else loadingOrError">
    <plotly-plot [data]="graph.data" [layout]="graph.layout" [config]="graph.config"></plotly-plot>
</ng-container>

<ng-template #loadingOrError>
    <ng-container [ngSwitch]="errorType">
        <ng-container *ngSwitchCase="errorTypeHelper.SERVER_CONNECTION_ERROR">
            {{ errorTypeHelper.SERVER_CONNECTION_ERROR | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="errorTypeHelper.NO_DATA_TO_SHOW">
          {{ errorTypeHelper.NO_DATA_TO_SHOW | translate }}
        </ng-container>
        <ng-container *ngSwitchDefault>
            <mat-spinner></mat-spinner>
        </ng-container>
    </ng-container>
</ng-template>